export default __webpack_public_path__ + "static/media/toyota-trust.e7ba4e44.svg";